export default __webpack_public_path__ + "static/media/micro-enterprise-service.be134807.png";